import React, { useState } from 'react'
import ExpandMoreIcon from '@material-ui/icons/ExpandMoreRounded'
import ExpandLessIcon from '@material-ui/icons/ExpandLessRounded'
import styled from '@emotion/styled'

const Container = styled.div`
  padding-left: 20px;
  height: 51px;
  display: flex;
  align-items: center;
`

const DriverText = styled.p`
  display: flex;
  color: #6b6c70;
`
const StyledExpandLessIcon = styled(ExpandLessIcon)`
  margin-left: 12px;
`
const StyledExpandMoreIcon = styled(ExpandMoreIcon)`
  margin-left: 12px;
`

const ExpandableDriver = ({ driverName, children }) => {
  const [expanded, setExpanded] = useState(false)

  return (
    <>
      <Container>
        <DriverText>
          {expanded ? (
            <StyledExpandLessIcon onClick={() => setExpanded(false)} />
          ) : (
            <StyledExpandMoreIcon onClick={() => setExpanded(true)} />
          )}{' '}
          {driverName}
        </DriverText>
      </Container>
      {expanded && children}
    </>
  )
}

export default ExpandableDriver
